module.exports = __webpack_public_path__ + "static/media/fraud-alert.c5e425b3.png";